import { forwardRef } from "react";
import styles from "./styles.module.css";

interface Props {
  src: string;
  className?: string;
}

export const FrameComponent = forwardRef<HTMLIFrameElement, Props>(
  ({ src, className }, ref) => {
    return (
      <iframe
        ref={ref}
        src={src}
        allow={"clipboard-write, clipboard-read"}
        className={`${styles.frame} ${className}`}
      ></iframe>
    );
  },
);
